import { render, staticRenderFns } from "./TabelaPercentual.vue?vue&type=template&id=8cd775c4&scoped=true"
import script from "./TabelaPercentual.vue?vue&type=script&lang=js"
export * from "./TabelaPercentual.vue?vue&type=script&lang=js"
import style0 from "./TabelaPercentual.vue?vue&type=style&index=0&id=8cd775c4&prod&lang=css"
import style1 from "./TabelaPercentual.vue?vue&type=style&index=1&id=8cd775c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd775c4",
  null
  
)

export default component.exports